import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import type { NexusEntryPoint } from '../components/steps/IntegrationStep/Nexus/types';
import { nexusReferralOf, type NexusReferralOptions } from '../nexusReferral';

export function useNexusReferralHandoff(
  open: (referralCode: NexusEntryPoint, options: NexusReferralOptions) => void,
  isNexusOpen: boolean,
): void {
  const location = useLocation();
  const navigate = useNavigate();
  const referral = nexusReferralOf(location.state);
  const nexusReferralCode = referral?.nexusReferralCode;
  const newConversation = referral?.newConversation ?? false;
  const cfOpening = referral?.cfOpening;
  const handledLocationKeyRef = useRef<string | null>(null);

  useEffect(() => {
    if (!nexusReferralCode || handledLocationKeyRef.current === location.key) {
      return;
    }
    handledLocationKeyRef.current = location.key;

    if (!isNexusOpen || newConversation) {
      open(nexusReferralCode, { newConversation, ...(cfOpening && { cfOpening }) });
    }
    navigate(location, { replace: true, state: null });
    // `cfOpening` is rebuilt from the page history on every render; the location already moves with it.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nexusReferralCode, newConversation, open, isNexusOpen, navigate, location]);
}
